import { RowsDescriptor } from './rows-descriptor';
import { RowsDescriptorType } from './rows-descriptor-type';

export class LoadingRowsDescriptor extends RowsDescriptor {
  constructor() {
    super(RowsDescriptorType.Loading);
  }
}
